import { render } from "./CursosDetalle.vue?vue&type=template&id=176c9938&ts=true"
import script from "./CursosDetalle.vue?vue&type=script&lang=ts"
export * from "./CursosDetalle.vue?vue&type=script&lang=ts"

import "./CursosDetalle.vue?vue&type=style&index=0&id=176c9938&lang=scss"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__